.description {
  font-size: var(--nexus-text-sm);
  color: var(--nexus-text-muted);
  line-height: 1.5;
  margin: 0;
}

/* Sits below the description for content the confirmation has to show rather
   than describe. Capped and scrollable so a long list cannot push the confirm
   and cancel buttons out of reach. */
.content {
  margin-top: var(--nexus-space-md);
  max-height: 40vh;
  overflow-y: auto;
}

.actions {
  display: flex;
  justify-content: flex-end;
  /* Three buttons (with a secondary action) can outgrow a phone-width modal;
     wrap rather than overflow. */
  flex-wrap: wrap;
  gap: var(--nexus-space-sm);
}
